@if (spec) {
    <div class="field">
        <label soho-label for="lm-builder-report-category">{{ 'ListPersonalizationModule' | translate }}</label>
        <select
                id="lm-builder-report-category"
                data-automation-id="lm-builder-report-category-input"
                soho-dropdown
                soho-trackdirty
                soho-busyindicator
                [moveSelected]="true"
                [blockUI]="true"
                [displayDelay]="0"
                [source]="onCategorySelect"
                [(ngModel)]="this.spec.formReport.category"
                (ngModelChange)="categoryChanged()">
            @for (option of categories; track option.value) {
                <option selected="{{option.value === this.spec.formReport.category}}" [value]="option?.value">{{option?.label}}</option>
            }
        </select>
    </div>
    <div class="field">
        <label soho-label for="lm-builder-report-subcategory">{{ 'ListPersonalizationCategory' | translate }}</label>
        <select
                id="lm-builder-report-subcategory"
                data-automation-id="lm-builder-report-subcategory-input"
                soho-dropdown
                soho-trackdirty
                soho-busyindicator
                [moveSelected]="true"
                [blockUI]="true"
                [displayDelay]="0"
                [source]="onSubcategorySelect"
                [(ngModel)]="this.spec.formReport.subcategory">
            @for (option of subcategories; track option.value) {
                <option selected="{{option.value === this.spec.formReport.subcategory}}" [value]="option?.value">{{option?.label}}</option>
            }
        </select>
    </div>
    <div class="field">
        <label soho-label for="lm-builder-report-description">{{ 'Description' | translate }}</label>
        <textarea
            id="lm-builder-report-description"
            data-automation-id="lm-builder-report-description-input"
            soho-textarea
            soho-trackdirty
            spellcheck="true"
            [(ngModel)]="spec.formReport.description"></textarea>
    </div>
}
